export const adyenPaymentTypes = {
  ideal: "ideal",
  creditCard: "creditcard",
  scheme: "scheme",
};
